import { RootState } from '@/store';
import { DashboardState, DASHBOARD_SLICE_NAME } from './models';

export const dashboardSelector = (state: RootState): DashboardState => state[DASHBOARD_SLICE_NAME];
